import React from 'react'
import { NavLink, useNavigate, } from 'react-router-dom'
import { useState, useRef, useEffect, useCallback } from 'react'
import carbuyImg from '../../../asses/not-found/logocarbuy-removebg-preview.png'
import { io } from 'socket.io-client'
import { useParams } from 'react-router-dom'

function Barnav({api1,setVisibilityPreSend, securityAdmin, freeVersion, setConsoleAdmin, englishActivate, consoleAdmin, setVisibilityChatClient, visibilityChatClient, setSecurityAdmin, setVisibilityClientFrontend, numberOrders, setVisibilityHamburguesas, setVisibilityCar, visibilityCar, numberBurgers, newMessageChat, tableNumber}) {
  const password = process.env.REACT_APP_PASSWORD_SERVICE1
  const [waiterRequest, setWaiterRequest] = useState(true)
  const socketRef = useRef(null);
  const navigate = useNavigate()
  const  mesaId  = tableNumber;

  // LOGICA SEGURIDAD ADMINISTRADOR

  useEffect(() => {
console.log("----->" + password)
  }, [])
  
  
  const verificationPasswordSecurity = (e) => {
    e.preventDefault()
    const challangeUser = prompt("Digite la contraseña del establecimiento")
  if(challangeUser === password){
  openAdmin()
  }
  else{
    alert("contraseña incorrecta")
  }
  
  
  }
  
const navigateFunction = () => {
  navigate("/service2/admin")

}

const openAdmin = () => {
  setSecurityAdmin(true)
setVisibilityClientFrontend(false)
navigateFunction()
} 
// useEffect(() => {
// if(securityAdmin === true){


// }
// }, [securityAdmin])



// FUNCIONES RELACIONADAS AL CARRITO


  const visibilityCarFunction = (e) => {
    e.preventDefault()
    setVisibilityCar(!visibilityCar)
    setVisibilityChatClient(false)
  }

  const visibilityChatFunction = (e) => {
    setVisibilityPreSend(false)
    e.preventDefault()
    setVisibilityCar(false)
    setVisibilityChatClient(!visibilityChatClient)
  }
  


const funcionChallengeVisibility = () => {
setVisibilityHamburguesas(true)

}



// LOGICA MESERO 


const [requestWaiter, setRequestWaiter] = useState(true)


 // Lógica para el mesero
 
  // Lógica para el mesero
const handleRequestWaiter = (e) => {
  setRequestWaiter(false);
  e.preventDefault()
  socketRef.current.emit('solicitar_mesero', tableNumber);  // Emitir solicitud de mesero
  // Deshabilitar el botón en el cliente
};


const [shouldDisconnect, setShouldDisconnect] = useState(false);
const pingIntervalRef = useRef(null);

const startPingPong = useCallback(() => {
  console.log('Iniciando el sistema de Ping-Pong');
  pingIntervalRef.current = setInterval(() => {
    console.log('Enviando ping al servidor con mesa:', tableNumber);
    socketRef.current.emit('ping', { tableNumber: tableNumber, id: socketRef.current.id });
  }, 60000); // Enviar ping cada 20 segundos
}, []); 

useEffect(() => {
  // Establecer la conexión del socket solo una vez
  socketRef.current = io(api1, {
    path: '/socket',
    transports: ['websocket', 'polling'],
  });

  socketRef.current.on('connect', () => {
    setConsoleAdmin(prevState => [...prevState, 'Conectado al servidor mesa: ' + tableNumber]);
    socketRef.current.emit('unirse_mesa', tableNumber);
    startPingPong();
  });

  socketRef.current.on('mesero_enviado', (tableNumber) => {
    setConsoleAdmin(prevState => [...prevState, "Se está enviando un mesero a la mesa " + tableNumber]);
    if (Number(tableNumber) === Number(mesaId)) {
      alert('El mesero ha sido enviado a tu mesa');
      setRequestWaiter(true);
    }
  });

const handleDisconnect = () => {
  socketRef.current.emit("custom_disconnect", tableNumber)
  stopPingPong(); 
}


// LOGICA PING PONG (EXPERIMENTAL)
socketRef.current.on('pong', (data) => {
  console.log('Pong recibido del servidor:', data); // Verificar si el pong se recibe correctamente
 startPingPong()
});

// Función para enviar un "ping" al servidor
// Detener el ping-pong cuando el cliente se desconecta
const stopPingPong = () => {
  console.log('Deteniendo el sistema de Ping-Pong'); // Confirmar que la función se ejecuta
  if (pingIntervalRef.current) {
    clearInterval(pingIntervalRef.current);
    pingIntervalRef.current = null;
  }
};

socketRef.current.on("pedidoRecibido", (table) => {
 if(Number(mesaId) === Number(table)){
  alert("La cocina esta preparando su orden.")
  console.log(" al receptor esta llegando almenos")
}
})

window.addEventListener("beforeunload", handleDisconnect)

// window.addEventListener("visibilitychange", handleDisconnect)
  // Agregar los event listeners para beforeunload y unload
  
  // Limpiar los eventos y el socket al desmontar el componente
  return () => {
    // window.removeEventListener("visibilitychange", handleDisconnect)
 window.removeEventListener("beforeunload", handleDisconnect)
    socketRef.current.off('mesero_enviado');
    socketRef.current.off('pedidoRecibido')
    stopPingPong(); 
    // socketRef.current.disconnect();
  };
}, [tableNumber]);


  return (
    <div className='container-buttons-barnav'>
     {  numberOrders < 4 && <button className='primary-button' id='btn-pedido' onClick={(e) => visibilityCarFunction(e)}><img src={carbuyImg} className='icono-btn' style={{marginLeft: "calc(50% - 20%)"}}  /><p style={{
      marginLeft: '-2px',
      backgroundColor: 'red',
      color: 'white',
      borderRadius: '50%',
      padding: '2px 8px',
      fontSize: '12px',
      fontWeight: 'bold',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: '20px',
      minHeight: '20px',
      textAlign: 'center',
      lineHeight: '1'
    }}>{numberBurgers}</p></button>
     
      }
      {!englishActivate &&  <button id='btn-mesero' disabled={freeVersion} onClick={(e) => handleRequestWaiter(e)}  className='primary-button'>Mesero </button>
      }  
      {englishActivate &&  <button id='btn-mesero' disabled={freeVersion} onClick={(e) => handleRequestWaiter(e)} className='primary-button'>Waiter </button>
      }  
        <button  id='btn-chat'  style={{justifyContent: "center"}} className='primary-button' onClick={(e) => visibilityChatFunction(e)}><h4 className='chat-larabel' style={{marginLeft: "4px"}}>Chat</h4>
    <p className='p-chat-2'>
      {newMessageChat}
    </p>
  </button>
      
        <button id='btn-administrado' onClick={(e) => verificationPasswordSecurity(e)} className='primary-button'><span style={{fontSize: "12px", color: "#0606b3"}}>Administrador</span> </button>
        
    
    </div>
  )
}

export default Barnav